import { render, staticRenderFns } from "./refund-batch-dialog.vue?vue&type=template&id=b86c873e&scoped=true"
import script from "./refund-batch-dialog.vue?vue&type=script&lang=js"
export * from "./refund-batch-dialog.vue?vue&type=script&lang=js"
import style0 from "./refund-batch-dialog.vue?vue&type=style&index=0&id=b86c873e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86c873e",
  null
  
)

export default component.exports